// @ts-nocheck
import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import auth from "@/framework/store/auth";
import group from "@/framework/store/group";
import hotel from "@/framework/store/hotel";
import error from "@/framework/store/error";
import coupon from "@/framework/store/coupon";
import voiceChat from "@/modules/voiceChat/store";
import component from "@/framework/store/component";
import conversation from "@/framework/store/conversation";
import inroom_admin from "@/framework/store/inroom_admin";
import ktznEventSubscription from "@/framework/store/ktznEventSubscription";
import ktznEventStoreSubscription from "@/framework/plugins/ktznEventStoreSubscription";

// Persistence with Local Storage
const dataState = createPersistedState({
  key: "KotoznaInroomStaffStore",
  paths: [
    "group.groupProfile",
    "group.state.groupProfiles",
    "group.invitedGroup",
    "auth",
    "hotel.checkin",
    "hotel.tenantId",
    "hotel.tenantLangCd",
    "component.appMode",
    "component.checkNotificationPermission",
    "inroom_admin",
    "conversation.unAssignedInquiryList",
  ],
  storage: window.localStorage,
});

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    component,
    conversation,
    group,
    hotel,
    voiceChat,
    ktznEventSubscription,
    error,
    inroom_admin,
    coupon,
  },
  plugins: [dataState, ktznEventStoreSubscription()],
});
